<ng-container *ngIf="costingLevelState$ | async as state">
    <div class="costing-level-container mat-elevation-z8">
        <div class="table-header">
            <mat-form-field subscriptSizing="dynamic">
                <input matInput #filter (keyup)="applyFilter($event.target.value)" placeholder="Filter">
                <button mat-icon-button matSuffix aria-label="clear" *ngIf="filter.value" (click)="filter.value=''; applyFilter('');">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
            <button mat-mini-fab
                    color="primary"
                    matTooltip="{{ 'app.page.costing-level.actions.add.label' | translate }}"
                    (click)="onAddKalkstufe()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
        <mat-progress-bar color="accent" [style.visibility]="state.isLoading ? 'visible' : 'hidden'" mode="indeterminate"></mat-progress-bar>

        <div class="table-container">
            <table mat-table [dataSource]="dataSource">

                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef>
                        <button mat-icon-button *ngIf="!isExpanded" (click)="expandAll()">
                            <mat-icon>chevron_right</mat-icon>
                        </button>
                        <button mat-icon-button *ngIf="isExpanded" (click)="collapseAll()">
                            <mat-icon>expand_more</mat-icon>
                        </button>
                        {{ "app.model.costing-level.name.label" | translate }}
                    </th>
                    <td mat-cell *matCellDef="let data">

                        <button mat-icon-button
                                [style.visibility]="!data.expandable ? 'hidden' : ''"
                                [style.marginLeft.px]="data.level * 32"
                                (click)="treeControl.toggle(data)">
                            <mat-icon class="mat-icon-rtl-mirror">
                                {{ treeControl.isExpanded(data) ? 'expand_more' : 'chevron_right' }}
                            </mat-icon>
                        </button>
                        @if (!data.other) {
                            {{ data.name }}
                        } @else {
                            {{ "app.model.costing-level.other.label" | translate }}
                        }
                    </td>
                </ng-container>


                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef></th>
                    <td mat-cell *matCellDef="let data" class="actions-column">
                        @if (!data.other) {
                            <button mat-icon-button
                                    color="primary"
                                    matTooltip="{{ 'app.page.costing-level.actions.edit.label' | translate }}"
                                    (click)="onEditKalkstufe(data)">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button
                                    color="warn"
                                    matTooltip="{{ 'app.page.costing-level.actions.delete.label' | translate }}"
                                    (click)="onDeleteCostingLevel(data)">
                                <mat-icon>delete</mat-icon>
                            </button>
                            <button mat-mini-fab
                                    color="primary"
                                    matTooltip="{{ 'app.page.costing-level.actions.add.label' | translate }}"
                                    (click)="onAddKalkstufe(data)">
                                <mat-icon>add</mat-icon>
                            </button>
                        }
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="layout.columns; sticky: true"></tr>
                <tr mat-row *matRowDef="let row; columns: layout.columns;"
                    [ngClass]="{'root-node' : row.parentCostingLevelId === null, 'parent-node': row.parentCostingLevelId !== null && row.children.length > 0}">
                </tr>
            </table>
        </div>
    </div>
</ng-container>
